import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlBundle } from '../../../models/urlBundle';
import { UrlProviderService } from '../../../services/url.provider';

@Component({
  selector: 'eid-unsupported-country-mobile',
  templateUrl: './unsupported-country.mobile.component.html',
  styleUrls: ['./unsupported-country.mobile.component.scss']
})
export class UnsupportedCountryMobileComponent {
  public urlBundle$: Observable<UrlBundle>;

  constructor(private urlProviderService: UrlProviderService) {
    this.urlBundle$ = this.urlProviderService.urlBundle$;
  }
}
